
window.Crafted  = (function (c) {

    c.Plugins = c.Plugins || {};
    c.Utilities = c.Utilities || {};

    return c;

})(window.Crafted || {});